import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { WagmiProvider } from 'wagmi';
import { 
  RainbowKitProvider, 
  darkTheme,
  getDefaultWallets
} from '@rainbow-me/rainbowkit';
import { config } from './config/wagmi';
import '@rainbow-me/rainbowkit/styles.css';

// Components
import Navbar from './components/Navbar';
import Home from './pages/Home';
import NFTGallery from './components/NFTGallery/NFTGallery';
import NFTDetail from './components/NFTDetail/NFTDetail';
import ErrorBoundary from './components/ErrorBoundary';

// Create a single QueryClient instance
const queryClient = new QueryClient();

// Configure wallet connectors
const { wallets } = getDefaultWallets({
  appName: 'Hotel NFT Collection',
  projectId: '7f0e3b311233367feafeeff44465cd33',
});

// Custom theme for RainbowKit
const appTheme = darkTheme({
  accentColor: '#0d6efd',
  accentColorForeground: 'white',
  borderRadius: 'medium',
  fontStack: 'system',
  overlayBlur: 'small',
});

function App() {
  return (
    <ErrorBoundary>
      <WagmiProvider config={config}>
        <QueryClientProvider client={queryClient}>
          <RainbowKitProvider 
            theme={appTheme}
            modalSize="compact"
            appInfo={{
              appName: 'Hotel NFT Collection',
              learnMoreUrl: 'https://example.com/learn-more',
            }}
          >
            <Router>
              <div className="min-h-screen bg-gray-100 dark:bg-gray-900">
                <Navbar />
                <main className="container mx-auto px-4 py-8">
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/gallery" element={<NFTGallery />} />
                    <Route path="/nft/:tokenId" element={<NFTDetail />} />
                  </Routes>
                </main>
              </div>
            </Router>
          </RainbowKitProvider>
        </QueryClientProvider>
      </WagmiProvider>
    </ErrorBoundary>
  );
}

export default App;
